/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { ElectricalSettingsComponent } from "../../components/tools/electrical-settings/electrical-settings.component";
import { ElectricalSettingsInfo } from "../../models/electrical-settings-model";
import { SysquePopupConfig } from "../../models/sysque-popup-config";
import { PopupDialog } from "../popup-dialog.interface";

export class ElectricalSettingsDialog implements PopupDialog {

  create(sysquePopupConfig: SysquePopupConfig): any {
    sysquePopupConfig.component = ElectricalSettingsComponent;
    sysquePopupConfig.data = new ElectricalSettingsInfo();
    (sysquePopupConfig.data as ElectricalSettingsInfo).firstSlideName = "Keyboard Shortcuts";
    (sysquePopupConfig.data as ElectricalSettingsInfo).secondSlideName = "Preferences";
    (sysquePopupConfig.data as ElectricalSettingsInfo).applyName = "Apply";
    (sysquePopupConfig.data as ElectricalSettingsInfo).restoreName = "Restore defaults";
    sysquePopupConfig.width = 770;
    sysquePopupConfig.height = 650;
    sysquePopupConfig.componentTitle = "SysQue Settings";
  }
}